var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M12 1.15c4.047 0 7.377 2.99 7.75 6.817l.02.24.008.179.043.009c1.111.247 1.876 1.023 2.008 2.253l.016.199.005.195v3.752c0 1.383-.732 2.281-1.858 2.6l-.172.043-.05.01-.015.195c-.242 2.784-1.672 3.856-4.549 4.126l-.265.022-.18.011-.002.026c-.055.495-.43.893-.917.997l-.124.02-.128.006h-2.606a1.167 1.167 0 01-1.17-1.023l-.006-.125v-1.297c0-.595.46-1.08 1.048-1.142l.128-.006h2.598c.604 0 1.105.445 1.17 1.022l.001.024.12-.008c2.219-.164 3.119-.796 3.339-2.549l.024-.224h-.412a.76.76 0 01-.736-.549l-.02-.098-.007-.102V9.06c0-.382.29-.693.66-.743l.103-.006.424-.001-.006-.09c-.222-2.976-2.684-5.358-5.774-5.578l-.238-.013-.23-.004c-3.227 0-5.88 2.354-6.221 5.373l-.021.222-.005.09h.423c.35 0 .646.232.736.55l.02.098.007.102v7.726c0 .382-.29.693-.66.742l-.103.007H4.978c-1.566 0-2.738-.901-2.823-2.55l-.005-.194v-3.752c0-1.384.732-2.281 1.858-2.6l.172-.043.043-.009.008-.18c.243-3.78 3.366-6.8 7.267-7.04l.255-.012L12 1.15z"
  }))));
}

export default SvgSupport;